import React from "react";
import {
  deleteData,
  getAlert,
  useEscapeClose,
} from "../../../utils/SamuiUtils";
// import WORD_ICON from "../../../../public/assets/img/word-logo.png";
// import EXCEL_ICON from "../../../../public/assets/img/excel-logo.png";
// import PDF_ICON from "../../../../public/assets/img/pdf-logo.png";

const FileModal = ({
  mode,
  openUploadAttach,
  setOpenUploadAttach,
  showViewAttachModal,
  setShowViewAttachModal,
  selectedFiles,
  selectedRecFiles,
  setSelectedFiles,
  handleRemoveImage,
  handleInputFileChange,
  handleBeforeUploadAttach,
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = React.useState(false);
  const [fileIndexToDelete, setFileIndexToDelete] = React.useState(null);
  const [showFilePreview, setShowFilePreview] = React.useState(false);
  const [currentPreviewFile, setCurrentPreviewFile] = React.useState(null);

  useEscapeClose(showDeleteConfirm, () => setShowDeleteConfirm(false));
  useEscapeClose(showFilePreview, () => setShowFilePreview(false));

  const handleFileSelection = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const filePromises = files.map((file, index) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: e.target.result,
            isPending: true,
            displayName: file.name,
          });
        };

        reader.onerror = () => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: URL.createObjectURL(file),
            isPending: true,
            displayName: file.name,
            useObjectUrl: true,
          });
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(filePromises)
      .then((processedFiles) => {
        const updatedFiles = [...selectedFiles, ...processedFiles];
        setSelectedFiles(updatedFiles);

        if (handleInputFileChange) {
          const modifiedEvent = {
            ...event,
            target: {
              ...event.target,
              files: processedFiles,
            },
          };
          handleInputFileChange(modifiedEvent);
        }
      })
      .catch((error) => { });

    event.target.value = "";
  };

  const handlePreviewFile = (file) => {
    let previewFile = null;

    // กรณีที่เป็น object จาก API (มี File_Url)
    if (typeof file === "object" && file !== null && file.File_Url) {
      const fileName = getFileNameFromUrl(file.File_Url);
      const fileExtension = fileName.split(".").pop() || "";
      const fileType = getFileTypeFromExtension(fileExtension);

      previewFile = {
        name: fileName,
        url: file.File_Url,
        type: fileType,
        isUrl: true,
      };
    }
    // กรณี object ที่อัปโหลดใหม่ (มี isPending = true)
    else if (typeof file === "object" && file !== null && file.isPending) {
      let previewUrl = null;

      // ลำดับความสำคัญในการหา URL สำหรับพรีวิว
      if (file.dataUrl) {
        // 1. ใช้ dataUrl ที่มีอยู่แล้ว (Base64)
        previewUrl = file.dataUrl;
      } else if (file.file) {
        // 2. สร้าง Object URL จาก File object
        previewUrl = URL.createObjectURL(file.file);
      }

      if (previewUrl) {
        previewFile = {
          name: file.name || file.displayName,
          url: previewUrl,
          type: file.type,
          isUrl: false,
          size: file.size,
          isObjectUrl: !file.dataUrl, // ถ้าไม่ใช่ dataUrl แสดงว่าเป็น Object URL
        };
      } else {
        getAlert("FAILED", "ไม่สามารถแสดงตัวอย่างไฟล์ได้ ไฟล์อาจเสียหาย");
        return;
      }
    }
    // กรณี string URL
    else if (typeof file === "string") {
      let finalUrl = file;

      if (!file.startsWith("http://") && !file.startsWith("https://")) {
        if (file.startsWith("/")) {
          finalUrl = `${window.location.origin}${file}`;
        } else {
          finalUrl = `${window.location.origin}/${file}`;
        }
      }

      const fileName = getFileNameFromUrl(finalUrl);
      const fileExtension = fileName.split(".").pop() || "";
      const fileType = getFileTypeFromExtension(fileExtension);

      previewFile = {
        name: fileName,
        url: finalUrl,
        type: fileType,
        isUrl: true,
      };
    }

    if (previewFile) {
      setCurrentPreviewFile(previewFile);
      setShowFilePreview(true);
    } else {
      getAlert("FAILED", "ไม่สามารถแสดงตัวอย่างไฟล์ได้ กรุณาตรวจสอบข้อมูลไฟล์");
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const fileToDelete = selectedFiles[fileIndexToDelete];

      if (typeof fileToDelete === "object" && fileToDelete.isPending) {
        const updatedFiles = selectedFiles.filter(
          (_, index) => index !== fileIndexToDelete
        );
        setSelectedFiles(updatedFiles);
      } else if (typeof fileToDelete === "object" && fileToDelete.File_Url) {
        await deleteData(
          "Upload_File_List",
          `WHERE File_Url = '${fileToDelete.File_Url}'`
        );
        selectedFiles.splice(fileIndexToDelete, 1);
      } else {
        await deleteData(
          "Upload_File_List",
          `WHERE File_Url = '${fileToDelete}'`
        );
        selectedFiles.splice(fileIndexToDelete, 1);
      }

      setFileIndexToDelete(null);
      setShowDeleteConfirm(false);
      getAlert("OK", "ลบไฟล์สําเร็จ");
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const getFileTypeFromExtension = (extension) => {
    const typeMap = {
      // รูปภาพ
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",

      // เอกสาร
      pdf: "application/pdf",

      // Microsoft Office
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",

      // ไฟล์ข้อความ
      txt: "text/plain",
      rtf: "application/rtf",

      // ไฟล์บีบอัด
      zip: "application/zip",
      rar: "application/x-rar-compressed",

      // ไฟล์วิดีโอ
      mp4: "video/mp4",
      avi: "video/x-msvideo",
      mov: "video/quicktime",

      // ไฟล์เสียง
      mp3: "audio/mpeg",
      wav: "audio/wav",
    };
    return typeMap[extension.toLowerCase()] || "application/octet-stream";
  };

  const getFileIcon = (fileType) => {
    if (fileType && fileType.startsWith("image/")) {
      return { icon: "fa-image", color: "#007bff" };
    } else if (fileType === "application/pdf") {
      return { icon: "fa-file-pdf-o", color: "#dc3545" };
    } else if (fileType && fileType.includes("word")) {
      return { icon: "fa-file-word-o", color: "#2b5ce6" };
    } else if (fileType && fileType.includes("sheet")) {
      return { icon: "fa-file-excel-o", color: "#28a745" };
    } else if (
      fileType &&
      (fileType.includes("powerpoint") || fileType.includes("presentation"))
    ) {
      return { icon: "fa-file-powerpoint-o", color: "#d24726" };
    } else if (fileType && fileType.includes("text")) {
      return { icon: "fa-file-text-o", color: "#6c757d" };
    } else if (
      fileType &&
      (fileType.includes("zip") ||
        fileType.includes("rar") ||
        fileType.includes("compressed"))
    ) {
      return { icon: "fa-file-archive-o", color: "#ffc107" };
    } else if (fileType && fileType.startsWith("video/")) {
      return { icon: "fa-file-video-o", color: "#e83e8c" };
    } else if (fileType && fileType.startsWith("audio/")) {
      return { icon: "fa-file-audio-o", color: "#20c997" };
    } else {
      return { icon: "fa-file-o", color: "#6c757d" };
    }
  };

  const getFileNameFromUrl = (url) => {
    try {
      const cleanUrl = url.split("?")[0].split("#")[0];
      const fileName = cleanUrl.split("/").pop() || "Unknown File";
      return decodeURIComponent(fileName);
    } catch (error) {
      console.error("Error parsing filename from URL:", error);
      return "Unknown File";
    }
  };

  const renderPreviewContent = (file) => {
    if (!file) return null;

    const { type, name, url } = file;

    if (type && type.startsWith("image/")) {
      return (
        <div className="text-center">
          <img
            src={url}
            alt={name}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
            className="img-fluid"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "block";
            }}
          />
          <div style={{ display: "none" }} className="alert alert-warning mt-3">
            <i className="fa fa-exclamation-triangle me-2"></i>
            ไม่สามารถแสดงรูปภาพได้ กรุณาตรวจสอบไฟล์
            <br />
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-primary mt-2"
            >
              <i className="fa fa-external-link me-1"></i>
              เปิดในแท็บใหม่
            </a>
          </div>
        </div>
      );
    }

    if (type === "application/pdf") {
      return (
        <div className="text-center">
          <iframe
            src={url}
            width="100%"
            height="500px"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title={`PDF Preview: ${name}`}
          />
          <p className="mt-2">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              <i className="fa fa-external-link me-2"></i>
              เปิด PDF ในแท็บใหม่
            </a>
          </p>
        </div>
      );
    }

    const getFileTypeName = (type) => {
      if (type && type.includes("word")) return "Word Document";
      if (type && type.includes("sheet")) return "Excel Spreadsheet";
      if (
        type &&
        (type.includes("powerpoint") || type.includes("presentation"))
      )
        return "PowerPoint Presentation";
      if (type === "application/pdf") return "PDF Document";
      if (type && type.includes("text")) return "Text Document";
      if (
        type &&
        (type.includes("zip") ||
          type.includes("rar") ||
          type.includes("compressed"))
      )
        return "Archive File";
      if (type && type.startsWith("video/")) return "Video File";
      if (type && type.startsWith("audio/")) return "Audio File";
      return "File";
    };

    return (
      <div className="text-center p-4">
        <div className="mb-3">
          <i
            className={`fa ${getFileIcon(type).icon}`}
            style={{ fontSize: "4rem", color: getFileIcon(type).color }}
          ></i>
        </div>
        <h5>{name}</h5>
        <p className="text-muted">{getFileTypeName(type)}</p>
        {file.size && (
          <p className="small">ขนาด: {formatFileSize(file.size)}</p>
        )}
        <div className="alert alert-info">
          <i className="fa fa-info-circle me-2"></i>
          ไม่สามารถแสดงตัวอย่างไฟล์นี้ได้ในเบราว์เซอร์
        </div>
        <a
          href={url}
          download={name}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          <i className="fa fa-download me-2"></i>
          ดาวน์โหลดไฟล์
        </a>
      </div>
    );
  };

  const handleClosePreview = () => {
    // ทำความสะอาด Object URL เพื่อป้องกัน memory leak
    if (currentPreviewFile && currentPreviewFile.isObjectUrl) {
      URL.revokeObjectURL(currentPreviewFile.url);
    }
    setCurrentPreviewFile(null);
    setShowFilePreview(false);
  };

  React.useEffect(() => {
    return () => {
      // ทำความสะอาด Object URLs ที่ยังค้างอยู่
      if (currentPreviewFile && currentPreviewFile.isObjectUrl) {
        URL.revokeObjectURL(currentPreviewFile.url);
      }

      // ทำความสะอาด Object URLs ในไฟล์ที่ใช้ useObjectUrl
      selectedFiles.forEach((file) => {
        if (file.useObjectUrl && file.dataUrl) {
          URL.revokeObjectURL(file.dataUrl);
        }
      });
    };
  }, []);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  // ฟังก์ชันสำหรับสร้าง Grid View ของไฟล์ (ปรับปรุงแล้ว)
  const renderFileGrid = (files, title, showDelete = false) => {
    if (!files || files.length === 0) {
      return (
        <div className="text-center py-5">
          <i
            className="fa fa-folder-open"
            style={{ fontSize: "48px", color: "#ccc", marginBottom: "15px" }}
          ></i>
          <h5 style={{ color: "#666" }}>ไม่มีไฟล์แนบ</h5>
          <p style={{ color: "#999", fontSize: "14px" }}>
            {showDelete
              ? 'คลิก "แนบไฟล์" เพื่อเพิ่มเอกสาร'
              : "ไม่พบเอกสารในส่วนนี้"}
          </p>
        </div>
      );
    }

    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
          gap: "20px",
          justifyContent: "start",
          padding: "10px",
        }}
      >
        {files.map((data, index) => {
          const isFileObject = typeof data === "object" && data.isPending;
          const isApiObject = typeof data === "object" && data.File_Url;

          let displayName, fileType, previewSrc;

          if (isFileObject) {
            displayName = data.displayName || data.name;
            fileType = data.type;
            previewSrc = data.dataUrl;
          } else if (isApiObject) {
            displayName = getFileNameFromUrl(data.File_Url);
            fileType = getFileTypeFromExtension(
              displayName.split(".").pop() || ""
            );
            previewSrc = data.File_Url;
          } else if (typeof data === "string") {
            displayName = getFileNameFromUrl(data);
            fileType = getFileTypeFromExtension(
              displayName.split(".").pop() || ""
            );
            previewSrc = data.startsWith("http")
              ? data
              : `${window.location.origin}/${data}`;
          } else {
            displayName = "Unknown";
            fileType = "";
            previewSrc = "";
          }

          const shortName =
            displayName.length > 18
              ? displayName.substring(0, 15) + "..."
              : displayName;

          const { icon, color } = getFileIcon(fileType);
          const isImage = fileType && fileType.startsWith("image/");

          return (
            <div
              key={isFileObject ? data.id : isApiObject ? data.F_Id : index}
              style={{
                border: "1px solid #ddd",
                borderRadius: "12px",
                padding: "15px",
                textAlign: "center",
                backgroundColor: isFileObject ? "#fff8e1" : "#fff",
                position: "relative",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                minHeight: "180px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
            >
              {/* Status indicator สำหรับไฟล์ที่รออัปโหลด */}
              {isFileObject && (
                <div
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    backgroundColor: "#ff9800",
                    borderRadius: "50%",
                    width: "16px",
                    height: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 2,
                  }}
                  title="รอการอัปโหลด"
                >
                  <i
                    className="fa fa-clock-o"
                    style={{ fontSize: "8px", color: "white" }}
                  ></i>
                </div>
              )}

              {/* Delete button - แสดงเฉพาะเมื่อ showDelete = true */}
              {showDelete && (
                <button
                  style={{
                    position: "absolute",
                    top: "8px",
                    left: "8px",
                    background: "#dc3545",
                    border: "none",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 2,
                    opacity: 0.9,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setFileIndexToDelete(index);
                    setShowDeleteConfirm(true);
                  }}
                  title="ลบไฟล์"
                  onMouseEnter={(e) => (e.target.style.opacity = "1")}
                  onMouseLeave={(e) => (e.target.style.opacity = "0.9")}
                >
                  <i
                    className="fa fa-times"
                    style={{ fontSize: "12px", color: "white" }}
                  ></i>
                </button>
              )}

              {/* Preview area - ปรับปรุงใหม่ */}
              <div
                style={{
                  marginBottom: "12px",
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                  backgroundColor: "#f8f9fa",
                  overflow: "hidden", // ป้องกันรูปภาพล้น
                }}
                onClick={() => handlePreviewFile(data)}
              >
                {isImage ? (
                  // แสดงรูปภาพจริงสำหรับไฟล์รูปภาพ
                  <img
                    src={previewSrc}
                    alt={displayName}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // ทำให้รูปเต็มพื้นที่โดยไม่บิดเบี้ยว
                      borderRadius: "6px",
                      border: "1px solid #eee",
                      transition: "transform 0.2s ease",
                    }}
                    onError={(e) => {
                      // ถ้าโหลดรูปไม่ได้ ให้แสดงไอคอนแทน
                      e.target.style.display = "none";
                      const iconContainer = e.target.nextSibling;
                      if (iconContainer) {
                        iconContainer.style.display = "flex";
                      }
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                    }}
                  />
                ) : null}

                {/* ไอคอนสำหรับไฟล์ที่ไม่ใช่รูปภาพ หรือเป็น fallback สำหรับรูปที่โหลดไม่ได้ */}
                <div
                  style={{
                    display: isImage ? "none" : "flex", // แสดงไอคอนเฉพาะไฟล์ที่ไม่ใช่รูป
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    flexDirection: "column",
                    gap: "4px",
                  }}
                >
                  <i
                    className={`fa ${icon}`}
                    style={{
                      fontSize: "36px", // ไอคอนใหญ่กว่าเดิมเล็กน้อย
                      color: color,
                      transition: "transform 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                    }}
                  ></i>
                  {/* แสดงนามสกุลไฟล์เล็กๆ ใต้ไอคอน */}
                  <span
                    style={{
                      fontSize: "9px",
                      color: color,
                      fontWeight: "600",
                      textTransform: "uppercase",
                    }}
                  >
                    {displayName.split(".").pop() || "FILE"}
                  </span>
                </div>
              </div>

              {/* File info */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {/* File name */}
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#333",
                    wordBreak: "break-word",
                    lineHeight: "1.3",
                    marginBottom: "8px",
                    minHeight: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title={displayName}
                >
                  {shortName}
                </div>

                {/* File size */}
                {isFileObject && data.size && (
                  <div
                    style={{
                      fontSize: "10px",
                      color: "#666",
                      marginBottom: "8px",
                    }}
                  >
                    {formatFileSize(data.size)}
                  </div>
                )}

                {/* Action buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  {/* Preview/View button */}
                  <button
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      color: "white",
                      padding: "4px 8px",
                      fontSize: "11px",
                      borderRadius: "6px",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      transition: "all 0.2s ease",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePreviewFile(data);
                    }}
                    title={isImage ? "ดูภาพขนาดเต็ม" : "ดูไฟล์"}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "rgb(204, 92, 0)";
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "rgb(239, 108, 0)";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <i className="fa fa-eye"></i>
                    <span>ดู</span>
                  </button>

                  {/* Download button */}
                  <a
                    href={previewSrc}
                    download={displayName}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      padding: "4px 8px",
                      fontSize: "11px",
                      textDecoration: "none",
                      borderRadius: "6px",
                      border: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      transition: "all 0.2s ease",
                    }}
                    onClick={(e) => e.stopPropagation()}
                    title="ดาวน์โหลด"
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#218838";
                      e.target.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#28a745";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <i className="fa fa-download"></i>
                    <span>โหลด</span>
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className={`modal ${showViewAttachModal ? "show" : ""}`}
      style={{ display: showViewAttachModal ? "block" : "none" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title">
              <i className="fa fa-paperclip me-2"></i>
              เอกสารแนบ
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => setShowViewAttachModal(false)}
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
              }}
            >
              <span>&times;</span>
            </button>
          </div>

          {/* เอกสารจากใบรับสินค้า */}
          {window.location.pathname === "/payment-voucher" &&
            Array.isArray(selectedRecFiles) && (
              <div
                className="modal-body"
                style={{ borderBottom: "1px solid #eee" }}
              >
                <h6
                  className="text-start mb-3"
                  style={{ color: "#666", fontWeight: "600" }}
                >
                  <i className="fa fa-file-text me-2"></i>
                  เอกสารจากใบรับสินค้า
                </h6>
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {selectedRecFiles.length > 0 ? (
                    renderFileGrid(
                      selectedRecFiles,
                      "เอกสารจากใบรับสินค้า",
                      false
                    )
                  ) : (
                    <div className="text-center py-4">
                      <i
                        className="fa fa-file-o"
                        style={{
                          fontSize: "36px",
                          color: "#ccc",
                          marginBottom: "12px",
                        }}
                      ></i>
                      <p style={{ color: "#999", fontSize: "14px", margin: 0 }}>
                        ไม่มีเอกสารจากใบรับสินค้า
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

          <div className="modal-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="mb-0" style={{ color: "#333", fontWeight: "600" }}>
                <i className="fa fa-folder me-2"></i>
                เอกสารแนบ
                {{
                  "/deposit-document": "ใบมัดจำ",
                  "/purchase-request": "ใบขอซื้อ",
                  "/purchase-order": "ใบสั่งซื้อ",
                  "/product-receipt": "ใบรับสินค้า",
                  "/payment-voucher": "ใบสำคัญจ่าย",
                  "/bill-of-lading": "ใบเบิก",
                  "/icebox": "ใบยืมสินค้า",
                  "/technical-equip-form": "ใบเบิกอุปกรณ์ช่าง",
                  "/office-equip-form": "ใบเบิกวัสดุใช้ภายใน",
                  "/quotation": "ใบเสนอราคา",
                  "/order-product": "ใบออเดอร์สินค้า",
                  "/billofsale": "ใบขาย",
                  "/picking-list": "Picking List",
                  "/bill": "ใบวางบิล",
                  "/invoice": "ใบกำกับภาษี",
                  "/tax": "หนังสือหัก ณ ที่จ่าย",
                }[window.location.pathname] || ""}
              </h6>
              {mode !== "S" && (
                <div>
                  <input
                    type="file"
                    multiple
                    accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.zip,.rar,.mp4,.avi,.mov,.mp3,.wav"
                    onChange={handleFileSelection}
                    style={{ display: "none" }}
                    id="file-upload-input"
                  />
                  <button
                    className="btn text-white"
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      whiteSpace: "nowrap",
                      padding: "12px 24px",
                      fontSize: "14px",
                      borderRadius: "8px",
                      border: "none",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onClick={() =>
                      document.getElementById("file-upload-input").click()
                    }
                  >
                    <i className="fa fa-plus"></i>
                    แนบไฟล์
                  </button>
                </div>
              )}
            </div>

            {/* Grid View ของไฟล์ */}
            <div style={{ maxHeight: "600px", overflowY: "auto" }}>
              {renderFileGrid(selectedFiles, "เอกสารแนบ", (mode !== "S" || window.location.pathname === '/icebox'))}
            </div>
          </div>
        </div>
      </div>

      {/* Modal Preview ไฟล์ */}
      <div
        className={`modal fade ${showFilePreview ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: showFilePreview ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.8)",
          zIndex: 1060,
        }}
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fa fa-eye me-2"></i>
                ตัวอย่างไฟล์: {currentPreviewFile?.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowFilePreview(false)}
                aria-label="Close"
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                }}
              >
                <span>&times;</span>
              </button>
            </div>
            <div
              className="modal-body text-center"
              style={{ maxHeight: "80vh", overflowY: "auto" }}
            >
              {renderPreviewContent(currentPreviewFile)}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowFilePreview(false)}
              >
                <i className="fa fa-times me-2"></i>
                ปิด
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal ยืนยันการลบไฟล์ */}
      <div
        className={`modal fade ${showDeleteConfirm ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: showDeleteConfirm ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                <i className="fa fa-exclamation-triangle me-2 text-warning"></i>
                ยืนยันการลบไฟล์
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setFileIndexToDelete(null);
                  setShowDeleteConfirm(false);
                }}
                aria-label="Close"
              />
            </div>
            <div className="modal-body text-center">
              <i
                className="fa fa-trash-o"
                style={{
                  fontSize: "48px",
                  color: "#dc3545",
                  marginBottom: "16px",
                }}
              ></i>
              <p style={{ fontSize: "16px", marginBottom: "8px" }}>
                คุณแน่ใจหรือไม่ที่จะลบไฟล์นี้?
              </p>
              <p style={{ fontSize: "14px", color: "#666" }}>
                เมื่อลบแล้วจะไม่สามารถกู้คืนได้อีก
              </p>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-lg shadow text-white d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#EF6C00",
                  fontSize: "16px",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  border: "none",
                  minWidth: "120px",
                  gap: "8px",
                }}
                onClick={handleConfirmDelete}
              >
                <i className="fa fa-check"></i>
                ยืนยัน
              </button>
              <button
                type="button"
                className="btn btn-lg shadow text-white"
                style={{
                  backgroundColor: "#6c757d",
                  fontSize: "16px",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  border: "none",
                  minWidth: "120px",
                  gap: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  setFileIndexToDelete(null);
                  setShowDeleteConfirm(false);
                }}
              >
                <i className="fa fa-times"></i>
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileModal;
